import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import ChatIcon from "../../assets/icons/ChatIcon";
import SendIcon from "../../assets/icons/SendIcon";
import { setUserData } from "../../store/slices/integrationSlice";
import styles from "./UsersList.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TgBotDialogWithUser } from "../TgBotDialogWithUser/TgBotDialogWithUser";
import {
  getTgBotChatHistory,
} from "../../utils/api/actions/dialogs";

export default function UsersList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dialogId = searchParams.get("dialogId");

  const { telegramBotUsers } = useSelector(
    (state) => state.integration
  );

  const [hoveredIndex, setHoveredIndex] = useState({
    chat: null,
    message: null,
  });

  // useEffect(() => {
  //   dispatch(getTelegramBotUsersList(activeBot.activeBot.id));
  //   dispatch(getAllDialogs(activeBot.activeBot.userId));
  // }, [dispatch, activeBot.activeBot.id, activeBot.activeBot.userId]);

  const handlerSendUserMessage = (item) => {
    dispatch(setUserData(item));
  };

  const handleGoToDialog = (id) => {
    navigate(`?dialogId=${id}`);
    dispatch(getTgBotChatHistory(id));
  };

  if (dialogId) {
    const user = telegramBotUsers?.find((item) => item.dialogId === dialogId);
    const userName = user?.firstName;
    return <TgBotDialogWithUser userName={userName} />;
  }

  const renderItem = (arr) => {
    return arr?.map((item, index) => (
      <div className={styles.itemContainer} key={index}>
        <label className={styles.titleItem}>{item.userName}</label>
        <label className={styles.titleItem} style={{ width: "20vw" }}>
          {item.bio}
        </label>
        <label className={styles.titleItem}>{item.chatId}</label>
        <label className={styles.titleItem}>{item.firstName}</label>
        <label className={styles.titleItem}>{item.lastName}</label>

        <div className={styles.actions}>
          <div
            className={styles.actionsIcon}
            onMouseEnter={() =>
              setHoveredIndex((prev) => ({ ...prev, chat: index }))
            }
            onMouseLeave={() =>
              setHoveredIndex((prev) => ({ ...prev, chat: null }))
            }
            onClick={() => {
              setHoveredIndex((prev) => ({ ...prev, chat: null }));
              handleGoToDialog(item.dialogId);
            }}
          >
            <ChatIcon
              size={23}
              fill={hoveredIndex.chat === index ? "#3e9fcb" : "#C0C0C0"}
            />
          </div>
          <div
            className={styles.actionsIcon}
            onMouseEnter={() =>
              setHoveredIndex((prev) => ({ ...prev, message: index }))
            }
            onMouseLeave={() =>
              setHoveredIndex((prev) => ({ ...prev, message: null }))
            }
            onClick={() => {
              setHoveredIndex((prev) => ({ ...prev, message: null }));
              handlerSendUserMessage(item);
            }}
          >
            <SendIcon
              fill={hoveredIndex.message === index ? "#3e9fcb" : "#C0C0C0"}
              size={23}
            />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <label className={styles.title}>Логин</label>
        <label className={styles.title} style={{ width: "20vw" }}>
          Описание
        </label>
        <label className={styles.title}>ID чата</label>
        <label className={styles.title}>Имя</label>
        <label className={styles.title}>Фамилия</label>
      </div>
      <div className={styles.list}>{renderItem(telegramBotUsers)}</div>
    </div>
  );
}
